import e from "../managers/braze-instance.js";
import { validateStandardString as R } from "../util/validation-utils.js";
export function setSdkAuthenticationSignature(t) {
  return (
    !!e.rr() &&
    !("" === t || !R(t, "set signature", "signature", !1)) &&
      (e.ii().setSdkAuthenticationSignature(t), !0)
  );
}
